import React from "react";
import { Link } from "react-router-dom";

import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

interface Props {
  image: string;
  title: string;
  description: React.ReactNode;
  action?: {
    type: "external" | "internal";
    route: string;
    color:
      | "primary"
      | "secondary"
      | "info"
      | "success"
      | "warning"
      | "error"
      | "dark"
      | "light"
      | "default";
    label: string;
    onClick?: () => void;
  };
  [key: string]: any;
  sx?: object;
}

function SimpleBlogCard({ image, title, description, action, sx, ...rest }: Props): JSX.Element {
  const renderAction = () => {
    if (action && typeof action.onClick === "function") {
      return (
        <MDButton variant="gradient" color={action.color ?? "dark"} onClick={action.onClick}>
          {action.label}
        </MDButton>
      );
    }

    if (action?.type === "external") {
      return (
        <MuiLink href={action.route} target="_blank" rel="noreferrer">
          <MDButton variant="gradient" color={action.color ?? "dark"}>
            {action.label}
          </MDButton>
        </MuiLink>
      );
    }

    if (action?.type === "internal") {
      return (
        <Link to={action.route}>
          <MDButton variant="gradient" color={action.color ?? "dark"}>
            {action.label}
          </MDButton>
        </Link>
      );
    }

    return null;
  };

  return (
    <Card
      sx={{ ...sx, display: "flex", flexDirection: "column" }} {...rest}
    >
      <MDBox>
        <MDBox position="relative" borderRadius="lg" mt={-3} mx={2}>
          <MDBox
            component="img"
            src={image}
            alt={title}
            borderRadius="lg"
            shadow="md"
            width="50%"
            height="auto"
            position="relative"
            zIndex={1}
            mx="auto"
            display="block"
          />
        </MDBox>

        <MDBox p={1}>
          <MDTypography
            display="block"
            variant="h6"
            textTransform="capitalize"
            fontWeight="bold"
            textAlign="center"
          >
            {title}
          </MDTypography>

          <MDBox mt={1} mb={1} minHeight="45px" textAlign="center">
            <MDTypography
              fontSize="default"
              textTransform="capitalize"
              fontWeight="Regular"
              textAlign="center"
            >
              {description}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox pb={1} textAlign="center" mt="auto">
        {renderAction()}
      </MDBox>
    </Card>
  );
}

export default SimpleBlogCard;
